import React from 'react'
import { Box } from '@chakra-ui/react'
import dynamic from 'next/dynamic'
import { LoadingSpinner } from 'components/feedback/loading/loading-spinner'
import {
  colorPalette,
  quillEditorStyle,
  quillWrapperStyles,
} from './TextEditor.styles'
import 'quill/dist/quill.snow.css'

const QuillEditor = dynamic(() => import('react-quill-new'), {
  ssr: false,
  loading: () => <LoadingSpinner />,
})

export { quillEditorStyle }

type TextEditorProps = {
  defaultValue?: string
  onChange: (value: string) => void
}
const TextEditor = ({ defaultValue, onChange }: TextEditorProps) => {
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      [{ align: [] }],
      [{ color: colorPalette }],
    ],
  }

  const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'link',
    'image',
    'align',
    'color',
    'code-block',
  ]

  return (
    <Box
      sx={quillWrapperStyles}
      borderRadius="md"
      flex="1"
      display="flex"
      flexDirection="column"
      overflow="visible"
    >
      <QuillEditor
        defaultValue={defaultValue}
        onChange={onChange}
        modules={quillModules}
        formats={quillFormats}
        theme="snow"
      />
    </Box>
  )
}

export default TextEditor
